import { http } from 'msw';

import { createGetSubscriptionFormQueryResponse } from '../mocks/createGetSubscriptionForm';

export const getSubscriptionFormHandler = http.get('*/subscription_form', function handler(info) {
  return new Response(JSON.stringify(createGetSubscriptionFormQueryResponse()), {
    headers: {
      'Content-Type': 'application/json',
    },
  });
});
